export function isFunction(x: any): x is Function {
  return typeof x === 'function';
}



// WEBPACK FOOTER //
// ../../../../node_modules/src/util/isFunction.ts